import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import Select from "react-select";
import InputField from "../../utils/InputField";
import Timeformat from "../../utils/Timeformat";
import StaticFunctions from "../../utils/StaticFunctions";
import Machines from "../../utils/entities/Machines";

class MachinesEditContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        machine: PropTypes.object.isRequired,
        changeView: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            datacollectorIds: [],
            machines: [],
            locations: [],
            companies: [],
            selectedCompanyId: (this.props.machine) ? this.props.machine.id_company : null,
            selectedLocationId: (this.props.machine) ? this.props.machine.id_location : null,
            machineOrder: (this.props.machine) ? this.props.machine.machine_order : null,
            inputError: [],
            inputParams: this.props.machine,
			manuallyHeadEdit: (this.props.machine) ? (this.props.machine.heads_manually_overwritten !== null) : false
        };

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);
        this.selectedCompany = this.props.baseData.companies.selectedCompany;

        this.requestCompaniesForSelection = this.requestCompaniesForSelection.bind(this);
        this.requestDataCollectorIds = this.requestDataCollectorIds.bind(this);
        this.requestCompanyMachines = this.requestCompanyMachines.bind(this);
        this.saveEditMachine = this.saveEditMachine.bind(this);
        this.getInput = this.getInput.bind(this);
        this.editSelect = this.editSelect.bind(this);
        this.selectCompany = this.selectCompany.bind(this);
        this.changeHeadInputField = this.changeHeadInputField.bind(this);
        this.getHeadsManuallyOverwrittenValue = this.getHeadsManuallyOverwrittenValue.bind(this);

    }

    componentWillMount() {

        this.requestCompaniesForSelection();
        this.requestDataCollectorIds();
        this.requestCompanyMachines();

    }

    requestCompaniesForSelection() {

        const selectedMachine = (this.props.machine) ? this.props.machine : null;

        if (selectedMachine) {
            const locations = StaticFunctions.getSelectOptionsFromArray(this.getLocationsByCompanyId(selectedMachine.id_company));
            const params = {
                action: 'getCompaniesForUser',
                currentCompanyId: this.props.baseData.companies.currentCompany.id,
                companyId: this.props.baseData.companies.currentCompany.id,
                userId: this.props.baseData.userData.id
            };

            const callback = function (res) {
                if (res) {
                    this.setState({
                        locations: locations,
                        companies: res
                    });
                }
            }.bind(this);

            this.api.request('AdminFunctions', params, callback, null);
        }

    }

    requestDataCollectorIds() {

        if (this.props.baseData.checkUserRole('superadmin') || this.props.baseData.checkUserRole('zskadmin') || this.props.baseData.checkUserRole('companyadmin')) {
            const params = {
                action: 'getDataCollectorSelectOptions',
                currentCompanyId: this.props.baseData.companies.currentCompany.id,
                userId: this.props.baseData.userData.id
            };

            const callback = function (res) {
                if (res) {
                    this.setState({
                        datacollectorIds: res
                    });
                }
            }.bind(this);

            this.api.request('AdminFunctions', params, callback, null);
        }

    }

    requestCompanyMachines() {

        const params = {
            action: 'getCompanyMachines',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            companyId: this.props.baseData.companies.currentCompany.id,
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    machines: res
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback);

    }

    enterSaveEditMachine(event) {

        if (event.keyCode === 13) {
            this.saveEditMachine();
        } else if (event.keyCode === 27) {
            this.changeView();
        }

    }

    saveEditMachine() {

		const inputParams = {...this.state.inputParams};

        if (inputParams && inputParams.machine_id && inputParams.machine_name) {
            const params = {
                action: 'saveCompanyMachine',
                currentCompanyId: this.props.baseData.companies.currentCompany.id,
                machineId: inputParams.machine_id,
                machineName: inputParams.machine_name,
                companyId: inputParams.id_company,
                locationId: inputParams.id_location,
                machineOrder: inputParams.machine_order,
				headsManuallyOverwritten: this.getHeadsManuallyOverwrittenValue(),
                datacollectorId: (inputParams.id_company !== this.props.machine.id_company) ? null : inputParams.id_datacollector,
                hideMachine: (inputParams.id_company !== this.props.machine.id_company) ? 'N' : inputParams.hide_machine
            };

            const callback = function(res) {
                this.resetInputError();

                if (res.success) {
                    alert(this.translate(res.msgKey));

                    this.props.changeView();
                } else {
                    this.setInputError(res.errors);
                }
            }.bind(this);

            this.api.request('AdminFunctions', params, callback, null);
        } else {
            if (!inputParams.machine_name) this.setInputError(['machine_name']);
        }

    }

    setInputError(errorFields) {

        this.setState({
            inputError: errorFields,
        });

    }

    resetInputError() {

        this.setState({
            inputError: [],
        });

    }

    getInput(event, name, value, isValid) {

        const inputParams = {...this.state.inputParams};

        inputParams[name] = (isValid) ? value : '';

        this.setState({inputParams});

    }

    editSelect(event, key) {

        const inputParams = {...this.state.inputParams};

        inputParams[key] = (event) ? event.value : null;

        this.setState({
            inputParams: inputParams
        });

    }

    selectCompany(event) {

        const inputParams = {...this.state.inputParams};

        const selectedCompanyId = (event && event.value) ? event.value : null;
        const locations = (selectedCompanyId !== null) ? StaticFunctions.getSelectOptionsFromArray(this.getLocationsByCompanyId(selectedCompanyId)) : null;

        inputParams['id_company'] = selectedCompanyId;
        inputParams['id_location'] = null;

        this.setState({
            locations: locations,
            inputParams: inputParams,
            selectedCompanyId: selectedCompanyId,
            selectedLocationId: null
        });

    }

    checkInputError(fieldName) {

        let result = 'ok';

        if (this.state.inputError) {
            let errorList = this.state.inputError;

            if (errorList.indexOf(fieldName) >= 0) result = 'error';
        }

        return result;

    }

    changeView() {

        if (this.props.changeView) this.props.changeView();

    }

	changeHeadInputField() {

		this.setState({
			manuallyHeadEdit: !this.state.manuallyHeadEdit
		});

	}

    getLocationsByCompanyId(id) {

        if (!id) return [];

        const locations = this.props.baseData.locations;

        return locations.filter((location) => String(location.id_company) === String(id));

    }

    getOrders() {

        const machines = this.state.machines;
        const options = [];

        let counter = 0;

        for (let i = 0; i < machines.length; i++) {
            const machine = machines[i];

            if (machine.machine_order !== null) {
                counter++;

                options.push({
                    label: counter,
                    value: counter
                });
            }
        }

        if (this.props.machine.machine_order === null) {
            counter++;

            options.push({
                label: counter,
                value: counter
            });
        }

        return options;

    }

	getHeadsManuallyOverwrittenValue() {

		const inputParams = {...this.state.inputParams};

		let value = null;

		if (this.state.manuallyHeadEdit) {
			value = (this.state.manuallyHeadEdit && inputParams.heads_manually_overwritten) ? inputParams.heads_manually_overwritten : inputParams.heads;
		}

		return value;

	}

	renderCompanyInputField() {

		const inputParams = {...this.state.inputParams};
		const companies = (this.state.companies.length > 0) ? this.state.companies : [];
		const selectedCompany = companies.find(o => String(o.value) === String(inputParams.id_company)) || null;

		if (this.props.baseData.checkUserRole('superadmin') || this.props.baseData.checkUserRole('zskadmin')) {
			return (
				<td className="text-left">
					<Select
						name="id_company"
						className={['chosen-container', 'chosen-container-single', this.checkInputError('companyId')].join(' ').trim()}
						style={{width: '260px'}}
						options={companies}
						value={selectedCompany}
						placeholder={this.translate('select') + '...'}
						clearable={false}
						noResultsText={this.translate('noResultsFound')}
						onChange={(event) => this.selectCompany(event)}
					/>
				</td>
			);
		} else {
			const value = StaticFunctions.getValueOfPropByKey(companies, inputParams.id_company,'value', 'label');

			return (
				<td className="text-left">
					<InputField
						name="name_company"
						value={value}
						disabled={true}
					/>
				</td>
			);
		}

	}

	renderDataCollectorInputField() {

		const inputParams = {...this.state.inputParams};
		const datacollectors = (this.state.datacollectorIds.length > 0) ? this.state.datacollectorIds : [];
		const selectedDatacollector = datacollectors.find(o => String(o.value) === String(inputParams.id_datacollector)) || null;

		if (this.props.baseData.checkUserRole('superadmin') || this.props.baseData.checkUserRole('zskadmin')) {
			return (
				<td className="text-left">
					<Select
						name="id_datacollector"
						className={['chosen-container', 'chosen-container-single', this.checkInputError('datacollectorId')].join(' ').trim()}
						style={{width: '260px'}}
						options={datacollectors}
						value={selectedDatacollector}
						placeholder={this.translate('select') + '...'}
						clearable={true}
						noResultsText={this.translate('noResultsFound')}
						onChange={(event) => this.editSelect(event, 'id_datacollector')}
					/>
				</td>
			);
		} else {
			return (
				<td className="text-left">
					<InputField
						name="number_dataCollector"
						value={inputParams.id_datacollector}
						disabled={true}
					/>
				</td>
			);
		}

	}

	renderHeadInputField() {

		const inputParams = {...this.state.inputParams};

		if (this.state.manuallyHeadEdit) {
			const value = inputParams.heads_manually_overwritten || inputParams.heads;

			return (
				<InputField
					name="heads_manually_overwritten"
					type="number"
					value={value}
					min="1"
					placeholder={inputParams.heads}
					onChange={this.getInput}
				/>
			);
		} else {
			return (
				<InputField
					name="heads"
					value={inputParams.heads}
					placeholder={inputParams.heads}
					disabled={true}
				/>
			);
		}

	}

	render() {

		if (!this.state.inputParams) return <LoadingSplash/>;

		const timezone = this.props.baseData.companies.currentCompany.timezone;
		const inputParams = {...this.state.inputParams};
		const companies = (this.state.companies.length > 0) ? this.state.companies : [];
		const locations = (this.state.locations.length > 0) ? this.state.locations : [];
        const orders = this.getOrders();

        const lastSeen = (inputParams.last_seen && parseInt(inputParams.last_seen) > 0) ? Timeformat.fromUnix(inputParams.last_seen).getFormatedDate(this.timeFormats.datetime, timezone) : '-';
        const lastOperation = (inputParams.last_operation && parseInt(inputParams.last_operation) > 0) ? Timeformat.fromUnix(inputParams.last_operation).getFormatedDate(this.timeFormats.datetime, timezone) : '-';

        return (
            <div className="formSettings">
                <nav>
                    <h1>{this.translate('machineSettings')}</h1>
                </nav>

                <div className="col-xs-12 col-lg-4">
                    <div className="formRow">
                        <table>
                            <tbody>
                                <tr>
                                    <td className="text-left labelSpan">{this.translate('machineId')}</td>

                                    <td className="text-left">
                                        <InputField
                                            name="machineId"
                                            value={inputParams.machine_id}
                                            disabled={true}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('machineName')}</td>

                                    <td className="text-left">
                                        <InputField
                                            name="machine_name"
                                            className={this.checkInputError('machine_name')}
                                            value={inputParams.machine_name}
                                            isRequired={true}
                                            onBlur={this.getInput}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('company')}</td>

									{this.renderCompanyInputField()}
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('location')}</td>

                                    <td className="text-left">
                                        <Select
                                            name="id_location"
                                            className={['chosen-container', 'chosen-container-single', this.checkInputError('locationId')].join(' ').trim()}
                                            style={{width: '260px'}}
                                            options={locations}
                                            value={locations.find(o => String(o.value) === String(inputParams.id_location)) || null}
                                            placeholder={this.translate('select') + '...'}
                                            clearable={true}
                                            noResultsText={this.translate('noResultsFound')}
                                            onChange={(event) => this.editSelect(event, 'id_location')}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('order')}</td>

                                    <td className="text-left">
                                        <Select
                                            name="machine_order"
                                            className={['chosen-container', 'chosen-container-single', this.checkInputError('machineOrder')].join(' ').trim()}
                                            style={{width: '260px'}}
                                            options={orders}
                                            value={orders.find(o => String(o.value) === String(inputParams.machine_order)) || null}
                                            placeholder={this.translate('select') + '...'}
                                            clearable={true}
                                            noResultsText={this.translate('noResultsFound')}
                                            onChange={(event) => this.editSelect(event, 'machine_order')}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('heads')}</td>

									<td className="text-left">
										{this.renderHeadInputField()}

										<a className="detailbutton" title={this.translate('headManuallyOverwritten')} onClick={() => this.changeHeadInputField()}>&nbsp;</a>
									</td>
								</tr>

								<tr>
                                    <td className="text-left labelSpan">{this.translate('needles')}</td>

                                    <td className="text-left">
                                        <InputField
                                            name="needles"
                                            value={inputParams.needles}
                                            disabled={true}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('osVersion')}</td>

                                    <td className="text-left">
                                        <input
                                            name="osVersion"
                                            type="text"
                                            value={(inputParams.t8_os_version && inputParams.t8_os_version !== '-1') ? inputParams.t8_os_version : '-'}
                                            disabled={true}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('tsVersion')}</td>

                                    <td className="text-left">
                                        <input
                                            name="tsVersion"
                                            type="text"
                                            value={(inputParams.t8_ts_version && inputParams.t8_ts_version !== '-1') ? inputParams.t8_ts_version : '-'}
                                            disabled={true}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('cpuVersion')}</td>

                                    <td className="text-left">
                                        <input
                                            name="cpuVersion"
                                            type="text"
                                            value={(inputParams.cpu_version && inputParams.cpu_version !== '-1') ? inputParams.cpu_version : '-'}
                                            disabled={true}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('dataCollector')}</td>

									{this.renderDataCollectorInputField()}
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('hideMachine')}</td>

                                    <td className="text-left">
                                        <Select
                                            name="hide_machine"
                                            className={['chosen-container', 'chosen-container-single', this.checkInputError('hideMachine')].join(' ').trim()}
                                            style={{width: '260px'}}
                                            options={[{value: 'Y', label: this.translate('yes')}, {value: 'N', label: this.translate('no')}]}
                                            value={inputParams.hide_machine}
                                            clearable={false}
                                            noResultsText={this.translate('noResultsFound')}
                                            onChange={(event) => this.editSelect(event, 'hide_machine')}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('lastSeen')}</td>

                                    <td className="text-left">
                                        <InputField
                                            name="lastSeen"
                                            value={lastSeen}
                                            disabled={true}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('lastOperation')}</td>

                                    <td className="text-left">
                                        <InputField
                                            name="lastOperation"
                                            value={lastOperation}
                                            disabled={true}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan webElement">&nbsp;</td>

                                    <td className="text-left">
                                        <a className="formButton" onClick={() => this.props.changeView()}>
                                            {this.translate('cancel')}
                                        </a>

                                        <a className="formButton" onClick={() => this.saveEditMachine()} onKeyDown={(event) => this.enterSaveEditMachine(event)}>
                                            {this.translate('save')}
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );

    }

}

export default MachinesEditContainer;
